import React from "react";
import { Card } from "../../components/ui/card";

function Comments({ content, id, img }) {
  return (
    <Card className="dark:bg-zinc-900/90 border dark:border-zinc-800 bg-gray-300 border-black/10  transition-all">
      <div className="p-3 flex gap-3 items-center">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full overflow-hidden ring-2 dark:ring-zinc-800/50 ring-black/10">
            <img 
              src={img} 
              alt={`${id}'s avatar`} 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Username */}
          <div className="text-[13px] font-medium dark:text-zinc-400 mb-0.5 text-start text-gray-800">
            {id}
          </div>
          
          {/* Comment Text */}
          <div className="text-[14px] dark:text-zinc-200 break-words text-start text-gray-700">
            {content}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default Comments;